import React, { useEffect, useRef } from "react";

const VideoComponent = ({ userData, isUserMenu, setShowImage }) => {
  const videoRef = useRef(null);

  const playVideo = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  };

  useEffect(() => {
    playVideo();
  }, []);

  return (
    <div className={isUserMenu ? "usermenu-url" : "other-url"}>
      <video
        ref={videoRef}
        muted
        loop
        playsInline
        style={{
          height: "100%",
          width: "100%",
          objectFit: "cover",
          position: "absolute",
          top: 0,
          left: 0,
          cursor: "pointer",
        }}
        onClick={() => {
          setShowImage && setShowImage(userData.bannerUrl);
        }}
      >
        <source src={userData.bannerUrl} type="video/mp4" />
      </video>
    </div>
  );
};

export default VideoComponent;
